/**
 *  Panel getters module file
**/

import { GETTERS } from './constants'

export const getters = {
  [GETTERS.GET_DEVICE_WIDTH]: (state) => state.deviceWidth,
  [GETTERS.GET_IS_MOBILE]: (state) => state.isMobile,
  [GETTERS.GET_ID]: (state) => state.config.id,
  [GETTERS.GET_LANGUAGE]: (state) => state.config.language,
  [GETTERS.GET_EXPLORERMODE]: (state) => state.config.explorerMode,
  [GETTERS.IS_MUPI_MODE]: (state) => state.config.mupiMode,
  [GETTERS.GET_AIRPORT]: (state) => state.airport,
  [GETTERS.GET_CARTOGRAPHY_TILES]: (state) => state.cartografyTiles,
  [GETTERS.GET_BLOCK_BBOX]: (state) => state.blockBbox,
  [GETTERS.GET_BBOX]: (state) => state.bbox,
  [GETTERS.GET_COORDINATES]: (state) => state.coordinates,
  [GETTERS.GET_ZOOM]: (state) => state.zoom,
  [GETTERS.GET_ACCESS_TOKEN]: (state) => state.accessToken,
  [GETTERS.GET_CATEGORY]: (state) => state.config.category,
  [GETTERS.GET_SUBCATEGORIES]: (state) => state.config.subcategories,
  [GETTERS.GET_AIRPORT_ID]: (state) => state.config.airport,
  [GETTERS.GET_BUILDING_ID]: (state) => state.config.building,
  [GETTERS.GET_FLOOR_ID]: (state) => state.config.floor,
  [GETTERS.GET_ROUTE_CONFIG]: (state) => state.config.route,
  [GETTERS.GET_FLOOR]: (state) => state.floor,
  [GETTERS.GET_BUILDING]: (state) => state.building,
  [GETTERS.GET_BUILDINGS]: (state) => state.buildings,
  [GETTERS.GET_POI_ID]: (state) => state.config.poi,
  [GETTERS.GET_POID_ID]: (state) => state.config.poiD,
  [GETTERS.GET_POI]: (state) => state.poi,
  [GETTERS.GET_POI_GROUPED]: (state) => state.pointGrouped,
  [GETTERS.GET_POIS_LIST]: (state) => state.poisList,
  [GETTERS.GET_TRANSITION_POIS_LIST]: (state) => state.transitionPoisList,
  [GETTERS.GET_UNCATEGORIZED_POIS_LIST]: (state) => state.uncategorizedPoisList,
  [GETTERS.GET_POIS_CATALOG]: (state) => state.poisCatalog,
  [GETTERS.GET_ACTIVE_FILTERS]: (state) => state.activeFilters,
  [GETTERS.GET_ROUTE]: (state) => state.route,
  [GETTERS.IS_ROUTE_MODE]: (state) => state.routeMode,
  [GETTERS.HAS_ROUTE]: (state) => !!(state.route.route || []).length,
  [GETTERS.GET_ROUTE_DEFAULT_LEVEL_BUILDING]: (state) => state.route.defaultLevelBuilding,
  [GETTERS.GET_ORIGIN]: (state) => state.route.steps.find(x => x.isOrigin),
  [GETTERS.GET_DESTINATION]: (state) => state.route.steps.find(x => x.isDestination),
  [GETTERS.GET_NEW_POINT]: (state) => state.route.steps.filter(x => !x.isOrigin && !x.isDestination),
  [GETTERS.HAS_NEW_POINT]: (state, getters) => getters[GETTERS.GET_NEW_POINT].some(x => x.new),
  [GETTERS.GET_VIEW]: (state) => state.view,
  [GETTERS.GET_LAYER_TREE]: (state) => state.layerTree,
  [GETTERS.PMR_CONFIG_VISIBLE]: (state) => state.show_pmr_config,
  [GETTERS.GET_PMR_PROFILE]: (state) => state.pmr_profile,
  [GETTERS.GET_DEFAULT_PMR_PROFILE]: () => 'pmr_1',
  [GETTERS.GET_FEEDBACK]: (state) => state.feedback,
  [GETTERS.GET_ROUTE_COUNT]: (state) => state.routeCount,
  [GETTERS.GET_PRINTMODE]: (state) => state.config.printMode,
  [GETTERS.GET_LONLAT]: (state) => [state.config.lon, state.config.lat],
  [GETTERS.GET_INITIAL_BBOX]: (state) => state.initialBbox,
  [GETTERS.GET_HOME_POSITION]: (state) => state.homePosition,
  [GETTERS.GET_FILTERING]: (state) => state.filtering,
  [GETTERS.GET_ZONAUBICACION]: (state) => state.config.zonaubicacion
}
